import { default as MoreButton } from './MoreButton';
import { default as MoreButtonNew } from './MoreButton.private_sell';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export { useHasMoreActions } from './MoreButton';
export default withFeatureBranch({
    private_sell: MoreButtonNew
})(MoreButton);

//# sourceMappingURL=index.js.map